"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const components_1 = require("../components");
const internal_1 = require("../components/internal");
const ComboBoxBase_1 = require("./internal/ComboBoxBase");
const ListBox_1 = require("./internal/ListBox");
const TextFieldBase_1 = require("./TextFieldBase");
const Value_1 = require("./Value");
function Autocomplete(props) {
    var _a, _b;
    const { onSelect, getOptionLabel, getOptionValue, getOptionMenuLabel, onInputChange, value = "", options, disabled, disabledOptions, ...others } = props;
    const disabledOptionsWithReasons = Object.fromEntries((_a = disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.map(ComboBoxBase_1.disabledOptionToKeyedTuple)) !== null && _a !== void 0 ? _a : []);
    const comboBoxProps = {
        isDisabled: !!disabled,
        disabledKeys: Object.keys(disabledOptionsWithReasons),
        onInputChange: onInputChange,
        inputValue: value,
        items: options,
        // Allow the user to type in a value that is not in the list. Allows for the text to stay in the input when the user clicks away
        allowsCustomValue: true,
        children: (item) => ((0, jsx_runtime_1.jsx)(react_stately_1.Item, { textValue: getOptionLabel(item), children: getOptionMenuLabel ? getOptionMenuLabel(item) : getOptionLabel(item) }, getOptionValue(item))),
        onSelectionChange: (key) => {
            const selectedItem = options.find((i) => getOptionValue(i) === key);
            if (selectedItem) {
                onInputChange(getOptionLabel(selectedItem));
                onSelect(selectedItem);
            }
        },
        ...others,
    };
    const state = (0, react_stately_1.useComboBoxState)(comboBoxProps);
    const inputWrapRef = (0, react_1.useRef)(null);
    const inputRef = (0, react_1.useRef)(null);
    const listBoxRef = (0, react_1.useRef)(null);
    const popoverRef = (0, react_1.useRef)(null);
    const { inputProps, listBoxProps, labelProps } = (0, react_aria_1.useComboBox)({
        ...comboBoxProps,
        inputRef,
        listBoxRef,
        popoverRef,
        // When the input is focused and there are options, open the menu
        onFocus: () => options.length > 0 && state.open(),
    }, state);
    // useOverlayPosition moves the overlay to the top of the DOM to avoid any z-index issues. Uses the `targetRef` to DOM placement
    const { overlayProps: positionProps } = (0, react_aria_1.useOverlayPosition)({
        targetRef: inputWrapRef,
        overlayRef: popoverRef,
        scrollRef: listBoxRef,
        isOpen: state.isOpen,
        onClose: state.close,
        placement: "bottom left",
    });
    positionProps.style = {
        ...positionProps.style,
        width: (_b = inputWrapRef === null || inputWrapRef === void 0 ? void 0 : inputWrapRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth,
        // Ensures the menu never gets too small.
        minWidth: 200,
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TextFieldBase_1.TextFieldBase, { inputRef: inputRef, inputWrapRef: inputWrapRef, inputProps: inputProps, labelProps: labelProps, onChange: onInputChange, clearable: true, 
                // Respect if caller to passes in `startAdornment={undefined}`
                startAdornment: "startAdornment" in props ? props.startAdornment : (0, jsx_runtime_1.jsx)(components_1.Icon, { icon: "search" }), ...others }), state.isOpen && ((0, jsx_runtime_1.jsx)(internal_1.Popover, { triggerRef: inputRef, popoverRef: popoverRef, positionProps: positionProps, onClose: () => state.close(), isOpen: state.isOpen, minWidth: 200, children: (0, jsx_runtime_1.jsx)(ListBox_1.ListBox, { ...listBoxProps, positionProps: positionProps, state: state, listBoxRef: listBoxRef, getOptionValue: (o) => (0, Value_1.valueToKey)(getOptionValue(o)), getOptionLabel: getOptionLabel, disabledOptionsWithReasons: disabledOptionsWithReasons }) }))] }));
}
exports.Autocomplete = Autocomplete;
